import { useEffect, useState, useMemo } from "react";
import { catalogByPart } from "../apis";

/**
 *
 * @returns Hook that brings the contents of the simplified classification label catalog.
 */

const useTagsCatalog = () => {
  const [tags, setTags] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await catalogByPart({
          is_own: false,
          catalogue: "TG-100",
          path: "/",
        });
        if (!resp.error) setTags(resp.data);
        else console.error("Error en API de tags:", resp);
      } catch (err) {
        console.error("Error en llamada de tags:", err);
      }
    };

    fetchData();
  }, []);

  const transformedType = useMemo(() => {
    return tags.reduce((acc, tag) => {
      acc[tag.key] = tag;
      return acc;
    }, {});
  }, [tags]);

  return transformedType;
};

export default useTagsCatalog;
